import React, {Component} from 'react';
import {AnalyticsParamValues} from '../../../../constants/analytics';
import Benefit from '../../../shared/benefit/benefit';
import NotFound from '../../../shared/not_found/notFound';
import Loader from '../../../../components/common/loader';
import './index.scss';

const CONTAINER_SELECTOR = '.benefits-grid:last-of-type';

class Results extends Component {
    constructor(props) {
        super(props);

        this.state = {
            shouldGetMoreData: true,
        };

        this.handleScroll = this.handleScroll.bind(this);
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    componentDidUpdate(prevProps) {
        const {data} = this.props;

        if (data !== prevProps.data) {
            this.setState({
                ...this.state,
                shouldGetMoreData: true,
            });

            this.forceUpdate();
        }
    }

    handleScroll() {
        const {data, onScroll} = this.props;
        const {shouldGetMoreData} = this.state;

        const resultsContainer = document.querySelector(CONTAINER_SELECTOR);

        if (!resultsContainer) {
            return;
        }

        const isBottom = this.isBottom(resultsContainer);
        const areThereMoreResults = data.metadata.totalLeftPages > 0;

        if (shouldGetMoreData && isBottom && areThereMoreResults) {
            onScroll(isBottom);

            this.setState({
                ...this.state,
                shouldGetMoreData: false,
            });
        }
    }

    isBottom(element) {
        return element.getBoundingClientRect().bottom <= window.innerHeight;
    }

    render() {
        const {data, translations, loading} = this.props;

        const promotedData = data.records.filter((benefitData) => benefitData.is_promoted);
        const regularData = data.records.filter((benefitData) => !benefitData.is_promoted);

        const analyticsSource = AnalyticsParamValues.CATEGORY_PAGE_SOURCE;

        return (
            <section className="category-results-container">
                {data && (
                    data.records.length > 0 ? (
                        <>
                            {promotedData.length > 0 && (
                                <div className="benefits-grid benefits-grid_promoted">
                                    {promotedData.map((benefitData) => (
                                        <Benefit
                                            key={benefitData.id}
                                            data={benefitData}
                                            analyticsSource={analyticsSource}
                                        />
                                    ))}
                                </div>
                            )}

                            {promotedData.length > 0 && regularData.length > 0 && (
                                <h3 className="regular-benefits-title">
                                    {translations['regular_benefits_see_more_title']}
                                </h3>
                            )}

                            {regularData.length > 0 && (
                                <div className="benefits-grid benefits-grid_regular">
                                    {regularData.map((benefitData) => (
                                        <Benefit
                                            key={benefitData.id}
                                            data={benefitData}
                                            analyticsSource={analyticsSource}
                                            smallVersion
                                        />
                                    ))}
                                </div>
                            )}
                        </>
                    ) : (
                        <NotFound/>
                    )
                )}

                {loading && (
                    <Loader className="benefits-loader"/>
                )}
            </section>
        );
    }
}


export default Results;
